import _ from 'lodash';
import winnerStatus from './winnerStatus.js';

const publicWinnerStatus = [
  { value: winnerStatus.ENTRY, text: 'Not a winner' },
  { value: winnerStatus.WINNER, text: 'Winner' },
  { value: winnerStatus.FIRST_PLACE, text: 'First Place' },
  { value: winnerStatus.SECOND_PLACE, text: 'Second Place' },
  { value: winnerStatus.THIRD_PLACE, text: 'Third Place' },
  { value: winnerStatus.FOURTH_PLACE, text: 'Fourth Place' },
  { value: winnerStatus.FIFTH_PLACE, text: 'Fifth Place' },
  { value: winnerStatus.SIXTH_PLACE, text: 'Sixth Place' },
  { value: winnerStatus.SEVENTH_PLACE, text: 'Seventh Place' },
  { value: winnerStatus.EIGHTH_PLACE, text: 'Eighth Place' },
  { value: winnerStatus.NINTH_PLACE, text: 'Ninth Place' },
  { value: winnerStatus.TENTH_PLACE, text: 'Tenth Place' },
  { value: winnerStatus.RUNNER_UP, text: 'Runner Up' },
  { value: winnerStatus.FINALIST, text: 'Finalist' },
];

publicWinnerStatus.ALL = _.values(publicWinnerStatus);

export default publicWinnerStatus;
